// Check widget registry, keyed by quality.point.test_type ID.
//
// Keyed by ID, never by technical name: the live instance has TWO test types
// whose technical name is 'picture' (id 10 legacy, id 15 current), so a
// name-keyed map mis-renders. Counts below are active workcentre-applied
// quality points observed on the instance.

import type { CheckWidget } from './types';

export const TEST_TYPE: Record<number, { widget: CheckWidget; allowNa?: boolean; label: string }> = {
  1: { widget: 'passfail', label: 'Pass - Fail' }, // 81 points
  15: { widget: 'photo', label: 'Take a Picture' }, // 26 points
  16: { widget: 'selection', label: 'Select Option' }, // 5 points
  23: { widget: 'value', label: 'Register Value' }, // 2 points
  2: { widget: 'measure', label: 'Measure' }, // 1 point
  17: { widget: 'passfail', allowNa: true, label: 'Yes No N/A' }, // 1 point
  27: { widget: 'passfail', allowNa: true, label: 'Pass Fail N/A' },
  14: { widget: 'confirm', label: 'Instructions' },
  9: { widget: 'confirm', label: 'Dummy' },
  10: { widget: 'photo', label: 'Take a Picture (legacy)' },
  22: { widget: 'photo', label: 'Multiple Images' },
  // Pour GRC: which registry mould cast this pod. Pass without a mould is
  // refused by Odoo, so this needs its own picker rather than the generic card.
  28: { widget: 'mould', label: 'Register Mould' }, // 1 point
  // Types with no designed body fall back to a generic confirm/fail/NA card
  // rather than pretending to handle them: 11 register_consumed_materials,
  // 18 print_label, 21 subcontractor_work, 24 register_gradient_falls,
  // 25 register_production, 26 spreadsheet.
};

export function widgetFor(testTypeId: number | null | undefined): {
  widget: CheckWidget;
  allowNa: boolean;
} {
  const entry = testTypeId != null ? TEST_TYPE[testTypeId] : undefined;
  return { widget: entry?.widget ?? 'generic', allowNa: entry?.allowNa ?? false };
}

/** Preset chips around the tolerance ceiling (the spec shows 5 for lippage). */
export function measurePresets(max: number | null): number[] {
  if (max == null || !Number.isFinite(max) || max <= 0) return [];
  const step = max / 2.5;
  const raw = [step, step * 1.5, step * 2, max, max * 1.4];
  const round = (n: number) => Math.round(n * 10) / 10;
  return [...new Set(raw.map(round))].slice(0, 5);
}
